// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"TopicHeader_mainContainer__27bp4","header":"TopicHeader_header__2Ro9x","form":"TopicHeader_form__179CV"};